import React from 'react';
import { ReferencePage } from './ReferencePage';
import { ContractNewForm } from '../../components/ContractNewForm';
import { useData } from '../../contexts/DataContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { TABLE_COLUMNS } from '../../constants/tables';
import { ContractNew } from '../../types';

export const ContractsPage: React.FC = () => {
  const { t } = useLanguage();
  const { contracts, contractors } = useData();

  return (
    <ReferencePage<ContractNew>
      title={t('references.contracts')}
      items={contracts.items}
      columns={TABLE_COLUMNS.CONTRACTS}
      onAdd={contracts.add}
      onEdit={contracts.edit}
      onDelete={contracts.remove}
      renderForm={({ theme, initialData, onSubmit, onCancel }) => (
        <ContractNewForm
          theme={theme}
          contractors={contractors.items}
          initialData={initialData}
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
      )}
    />
  );
};
